import OTPForm from '../devise/otp_form';

document.addEventListener('DOMContentLoaded', function() {
  OTPForm.init();
});
